import React, {useState, useEffect} from 'react'

export default function CharacterSpin({children}) {
  
  const timeFactor = 5000;

  const mainInterval = (Math.random() * timeFactor) + 2000
  let [ch, setCh] = useState(children)
  const chars = ['%', 's', '£', '.', '@', '+', '!', 'd', '}', 'R']


  useEffect(() => {

    let interval = setInterval(()=>{
      let delay = 0
      let delayIncrement = 40
      chars.forEach(el => {
        setTimeout(()=> {
           setCh(el)
          }, delay)
          delay = delay + delayIncrement
      });
      setTimeout(() => setCh(children), delay )
  
    }, mainInterval)

    return () => clearInterval(interval)
  }, [chars, children, mainInterval])




  return (
    <span>
      {ch}
    </span>
  )
}
